import React, { useState, useEffect, useRef } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Image } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import {
    EXERCISE_API,
    BaseGatewayImage,
    DISEASE_API,
    ACCOUNT_API,
    PATIENTEXERCISE_API,
    PATIENTEXERCISEPRACTICE_API
} from '@app/utils/apiUrl.js';
import { DeleteSingle, Get, Post, Put } from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    dateTimeToString,
    dateTimeToStringRequest,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue,
    sortByValue,
    objectPracticeStatus,
    practiceStatus,
    status200,
    status201
} from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { BrowserView, MobileView } from 'react-device-detect';
import Select from 'react-select';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { isMobile } from 'react-device-detect';
import { Formik } from 'formik';
import * as yup from 'yup';
import VideoInput from '@app/components/video-input/VideoInput';
import MultiVideoInput from '@app/components/video-input/MultiVideoInput';
import * as moment from 'moment';

// const schema = yup.object().shape({
//     videoLink: yup.string().required('Trường dữ liệu không được để trống')
// });

const schemaPatientResponse = yup.object().shape({
    feedbackPatient: yup.string().required('Trường dữ liệu không được để trống')
});

const PatientPractice = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);
    const queryClient = useQueryClient();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10000);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [isAddedPractice, setIsAddedPractice] = useState(false);

    const timeCurentDay = moment();

    const videoRef = useRef();
    const descRef = useRef();

    // let accountRoleAdmin = false;
    const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Doctor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(PATIENTEXERCISEPRACTICE_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));

    const [patientExerciseId, setPatientExerciseId] = useState(
        paramUrl.get('chonbaiId') || ''
    );

    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [exerciseId, setExerciseId] = useState(
    //     paramUrl.get('baitapId') ? paramUrl.get('baitapId') : ''
    // );
    // const [accountDoctorId, setAccountDoctorId] = useState(
    //     paramUrl.get('bacsiId') ? paramUrl.get('bacsiId') : ''
    // );

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    // const {isLoading, isError, error, data, refetch} = useQuery(
    //     ['exerciseData', valueSearch, page, pageSize],
    //     () => {
    //         let model = {
    //             Keyword: valueSearch ? valueSearch : '',
    //             PageIndex: page,
    //             PageSize: pageSize,
    //             DiseaseId:
    //                 diseaseId && diseaseId.target && diseaseId.target.value
    //                     ? diseaseId.target.value.value
    //                     : ''
    //         };

    //         return Get(EXERCISE_API.GET_PAGING, null, model);
    //     }
    // );

    // const exerciseItem = useQuery(
    //     ['exercisePatientData', exerciseId],
    //     () => {
    //         if (exerciseId) {
    //             return Get(EXERCISE_API.GET_ITEM, exerciseId);
    //         }
    //     },
    //     {
    //         // enabled: !!exerciseId,
    //         // refetchOnMount: false
    //     }
    // );

    // const accountDoctorItem = useQuery(
    //     ['doctorPatientData', accountDoctorId],
    //     () => {
    //         if (accountDoctorId) {
    //             return Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, accountDoctorId);
    //         }
    //     },
    //     {
    //         // enabled: !!accountDoctorId,
    //         // refetchOnMount: false
    //     }
    // );

    const patientExerciseItem = useQuery(
        ['patientExerciseItemData', patientExerciseId],
        () => {
            return Get(PATIENTEXERCISE_API.GET_ITEM, patientExerciseId);
        },
        {
            // keepPreviousData: true,
            // cacheTime: 0
            // don’t even start this query until we have the patient’s account
            // enabled: !!inforAccount.id,
            // always refetch when this useQuery hook is mounted:
            // refetchOnMount: false
        }
    );

    // let keyPatientExerciseItem = [
    //     'patientExerciseData',
    //     inforAccount.id,
    //     accountDoctorId,
    //     exerciseId,
    //     page,
    //     pageSize
    // ];

    // const lstPatientExerciseItem = useQuery(
    //     keyPatientExerciseItem,
    //     () => {
    //         var model = {
    //             PageIndex: page,
    //             PageSize: pageSize,
    //             AccountPatientId: inforAccount.id,
    //             AccountDoctorId: accountDoctorId,
    //             ExerciseId: exerciseId
    //         };
    //         return Get(PATIENTEXERCISE_API.GET_PAGING, null, model);
    //     },
    //     {
    //         // keepPreviousData: true,
    //         cacheTime: 0
    //         // don’t even start this query until we have the patient’s account
    //         // enabled: !!inforAccount.id,
    //         // always refetch when this useQuery hook is mounted:
    //         // refetchOnMount: false
    //     }
    // );

    // useEffect(() => {
    //     queryClient.invalidateQueries('patientExerciseData');
    //     queryClient.invalidateQueries('exercisePatientData');
    //     queryClient.invalidateQueries('doctorPatientData');
    // }, []);

    const isLoading = patientExerciseItem.isLoading ? true : false;
    const isError = patientExerciseItem.isError ? true : false;
    const error = patientExerciseItem.isError ? exerciseItem.error : null;

    // useEffect(() => {
    //     if (!videoRef.current || !descRef.current) return;
    //     if (videoRef.current.offsetHeight === 0) return;

    //     // bottom of the videoLink relative to the description container
    //     const bottomOfVideo =
    //         videoRef.current.offsetTop + videoRef.current.offsetHeight;

    //     descRef.current.querySelectorAll('figure').forEach((fig) => {
    //         // if the figure’s top is below the video’s bottom → center it
    //         if (fig.offsetTop > bottomOfVideo + 30) {
    //             fig.classList.add('centered');
    //         } else {
    //             fig.classList.remove('centered');
    //         }
    //     });
    // }, [exerciseItem.data]);

    // useEffect(() => {
    //     refetch();
    // }, [pageSize, page]);

    // useEffect(() => {
    //     if (location.pathname === URI_INTERNAL.PATIENTPRACTICE_PATH) {
    //         lstPatientExerciseItem.refetch();
    //     }
    // }, [location.pathname, location.search]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.PATIENTPRACTICE_PATH, {
                page: Page,
                size: Size,
                search: Search,
                chonbaiId: patientExerciseId
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    useEffect(() => {
        if (isAddedPractice) {
            patientExerciseItem.refetch();

            setIsAddedPractice(false);
        }
    }, [isAddedPractice]);

    // useEffect(() => {
    //     if (!accountDoctorId && !exerciseId) {
    //         if (
    //             lstPatientExerciseItem &&
    //             lstPatientExerciseItem.data &&
    //             lstPatientExerciseItem.data.data &&
    //             lstPatientExerciseItem.data.data.length > 0
    //         ) {
    //             const rawList = lstPatientExerciseItem.data.data;
    //             // console.log('rawList', rawList);
    //             if (Array.isArray(rawList) && rawList.length > 0) {
    //                 // Tạo bản sao của mảng để không thay đổi trực tiếp mảng gốc
    //                 const sortedList = [...rawList].sort((a, b) => {
    //                     // Hàm helper để tìm createdDate lớn nhất trong mỗi patientExercisePractices
    //                     const getLatestDate = (practices) => {
    //                         if (
    //                             !Array.isArray(practices) ||
    //                             practices.length === 0
    //                         ) {
    //                             // Nếu không có practices hoặc rỗng, trả về giá trị rất cũ để đẩy xuống cuối
    //                             return new Date(0);
    //                         }
    //                         // Chuyển tất cả createdDate thành Date và lấy giá trị max
    //                         return practices
    //                             .map((p) => new Date(p.createdDate))
    //                             .reduce(
    //                                 (max, curr) => (curr > max ? curr : max),
    //                                 new Date(0)
    //                             );
    //                     };

    //                     const maxDateA = getLatestDate(
    //                         a.patientExercisePractices
    //                     );
    //                     const maxDateB = getLatestDate(
    //                         b.patientExercisePractices
    //                     );

    //                     // Muốn sắp xếp giảm dần: nếu maxDateB > maxDateA thì trả về 1 (đổi chỗ), ngược lại trả về -1
    //                     if (maxDateA < maxDateB) return 1;
    //                     if (maxDateA > maxDateB) return -1;
    //                     return 0;
    //                 });

    //                 console.log('sortedList', sortedList);

    //                 const firstItem = sortedList[0];
    //                 setExerciseId(firstItem.exerciseId);
    //                 setAccountDoctorId(firstItem.accountDoctorId);

    //                 // exerciseItem.refetch();
    //                 // accountDoctorItem.refetch();
    //             }
    //         }
    //     }
    // }, [lstPatientExerciseItem.data]);

    // useEffect(() => {
    //     if (exerciseId) {
    //         exerciseItem.refetch();
    //     }
    // }, [exerciseId]);

    // useEffect(() => {
    //     if (accountDoctorId) {
    //         accountDoctorItem.refetch();
    //     }
    // }, [accountDoctorId]);

    // useEffect(() => {
    //     if (accountDoctorId && exerciseId) {
    //         lstPatientExerciseItem.refetch();
    //         // history.replace(
    //         //     createUrlWithParam(URI_INTERNAL.PATIENTPRACTICE_PATH, {}
    //         // ));
    //     }
    // }, [accountDoctorId, exerciseId]);

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        patientExerciseItem.refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        // if (
                        //     data != null &&
                        //     data.data.length === 1 &&
                        //     page !== 1
                        // ) {
                        //     history.push(
                        //         createUrlWithParam(URI_INTERNAL.EXERCISE_PATH, {
                        //             page: page - 1,
                        //             size: pageSize,
                        //             search: search
                        //         })
                        //     );
                        // }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    // const loadOptions = async (search, loadedOptions, {page}) => {
    //     const pageSize = 10;
    //     const res = await Get(DISEASE_API.GET_PAGING, null, {
    //         PageIndex: page,
    //         PageSize: pageSize,
    //         Keyword: search // pass the input text to filter server-side
    //     });

    //     const data = res.data || [];
    //     const options = data.map((x) => ({
    //         label: `${x.name}`,
    //         value: x.id
    //     }));

    //     // assume your API returns total count or a flag for more pages
    //     const hasMore = data.length === pageSize;
    //     return {
    //         options,
    //         hasMore,
    //         additional: {page: page + 1}
    //     };
    // };

    let videoLink = '';
    if (
        patientExerciseItem &&
        patientExerciseItem.data &&
        patientExerciseItem.data.exercise
    ) {
        if (isValidUrl(patientExerciseItem.data.exercise.videoLink)) {
            if (
                patientExerciseItem.data.exercise.videoLink.includes(
                    'www.youtube.com'
                )
            ) {
                videoLink = patientExerciseItem.data.exercise.videoLink.replace(
                    'watch?v=',
                    'embed/'
                );
            }
            videoLink = patientExerciseItem.data.exercise.videoLink;
        } else {
            videoLink =
                BaseGatewayImage + patientExerciseItem.data.exercise.videoLink;
        }
    }

    // const doMeasure = () => {
    //     const vidEl = videoRef.current;
    //     const descEl = descRef.current;
    //     if (!vidEl || !descEl) return;

    //     // now offsetHeight will be correct
    //     const bottom = vidEl.offsetTop + vidEl.offsetHeight;

    //     // descEl.querySelectorAll('figure').forEach((fig) => {
    //     //     if (fig.offsetTop > bottom) fig.classList.add('centered');
    //     //     else fig.classList.remove('centered');
    //     // });
    //     descEl.querySelectorAll('figure, img').forEach((el) => {
    //         if (el.offsetTop > bottom) {
    //             el.classList.add('centered');
    //         } else {
    //             el.classList.remove('centered');
    //         }
    //     });
    // };

    const addFunc = useMutation((value) =>
        Post(PATIENTEXERCISE_API.ADD_ITEM, null, value, false, true)
    );

    const addPracticeFunc = useMutation((value) =>
        Post(PATIENTEXERCISEPRACTICE_API.ADD_ITEM, null, value, false)
    );

    const updatePracticeFunc = useMutation(({ value, id }) =>
        Put(PATIENTEXERCISE_API.UPDATE_ITEM, id, value)
    );

    const handleCreate = async (values) => {
        const model = { ...values };

        // var newList =
        //     lstPatientExerciseItem &&
        //     lstPatientExerciseItem.data &&
        //     lstPatientExerciseItem.data.data
        //         ? lstPatientExerciseItem.data.data.sort(
        //               (a, b) =>
        //                   new Date(b.createdDate).getTime() -
        //                   new Date(a.createdDate).getTime()
        //           )
        //         : [];

        // var newestStatus =
        //     newList && newList[0] ? newList[0].patientExerciseStatus : '';

        // var patientExerciseId =
        //     newList && newList[0] && newestStatus == practiceStatus.InProgress
        //         ? newList[0].id
        //         : '';

        // if (
        //     newestStatus == '' ||
        //     newestStatus == practiceStatus.Reviewed ||
        //     newestStatus == practiceStatus.Rejected
        // ) {
        //     var modelPractice = {
        //         exerciseId: exerciseId,
        //         accountDoctorId: accountDoctorId,
        //         accountPatientId: inforAccount.id,
        //         patientExerciseStatus: practiceStatus.InProgress,
        //         feedbackDoctor: '',
        //         feedbackPatient: ''
        //     };
        //     await addFunc.mutateAsync(modelPractice, {
        //         onSuccess: (res) => {
        //             patientExerciseId = res.id;
        //         },
        //         onError: (res) => {
        //             toast.error(
        //                 res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
        //             );
        //         }
        //     });
        // }

        if (patientExerciseId) {
            model.patientExerciseId = patientExerciseId;
            await addPracticeFunc.mutateAsync(model, {
                onSuccess: async (res) => {
                    if (res.status !== status200 && res.status !== status201) {
                        toast.error(messageToast.messageToastCreateError);
                    } else {
                        // await lstPatientExerciseItem.refetch();
                        setIsAddedPractice(true);
                        // await queryClient.refetchQueries(keyPatientExerciseItem);
                        toast.success(messageToast.messageToastCreateSuccess);
                    }
                },
                onError: async (res) => {
                    toast.error(
                        res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                    );
                }
            });
        }
    };

    const [visibleVideos, setVisibleVideos] = useState({});

    const toggleVideo = (practiceId) => {
        setVisibleVideos((prev) => ({
            ...prev,
            [practiceId]: !prev[practiceId]
        }));
    };

    const handleUpdatePracticeStatus = async (practiceStatusUpdate, id) => {
        var model = { ...patientExerciseItem.data };

        if (
            practiceStatusUpdate == practiceStatus.Pending ||
            practiceStatusUpdate == practiceStatus.InProgress
        ) {
            model.patientExerciseStatus = practiceStatusUpdate;
        }

        if (model) {
            await updatePracticeFunc.mutateAsync(
                { value: model, id: id },
                {
                    onSuccess: (res) => {
                        if (res.status !== status200) {
                            toast.error(messageToast.messageToastUpdateError);
                        } else {
                            toast.success(
                                messageToast.messageToastUpdateSuccess
                            );

                            setIsAddedPractice(true);
                            // queryClient.setQueryData(diseaseId, model);
                            // queryClient.invalidateQueries([exerciseId]);
                            // history.goBack();

                            // queryClient.invalidateQueries([
                            //     'patientExerciseData',
                            //     inforAccount.id,
                            //     accountDoctorId,
                            //     exerciseId,
                            //     page,
                            //     pageSize
                            // ]);
                        }
                    },
                    onError: (res) => {
                        toast.error(
                            res.message ||
                            'Đã có lỗi xảy ra, vui lòng thử lại !'
                        );
                    }
                }
            );
        }
    };

    const handleUpdate = async (values, id) => {
        var model = { ...patientExerciseItem.data };
        if (
            model.patientExerciseStatus == practiceStatus.Reviewed ||
            model.patientExerciseStatus == practiceStatus.Rejected
        ) {
            model.feedbackPatient = values.feedbackPatient;
        }
        if (model && model.feedbackPatient) {
            await updatePracticeFunc.mutateAsync(
                { value: model, id: id },
                {
                    onSuccess: (res) => {
                        if (res.status !== status200) {
                            toast.error(messageToast.messageToastUpdateError);
                        } else {
                            toast.success('Gửi phản hồi thành công!');
                            setIsAddedPractice(true);
                            // queryClient.setQueryData(diseaseId, model);
                            // queryClient.invalidateQueries([patientExerciseId]);
                            // history.goBack();

                            // queryClient.invalidateQueries([
                            //     'patientExerciseData',
                            //     inforAccount.id,
                            //     accountDoctorId,
                            //     exerciseId,
                            //     page,
                            //     pageSize
                            // ]);
                        }
                    },
                    onError: (res) => {
                        toast.error(
                            res.message ||
                            'Đã có lỗi xảy ra, vui lòng thử lại !'
                        );
                    }
                }
            );
        } else {
            toast.error('Đã phản hồi');
        }
    };

    const exerciseDetailRef = useRef(null);
    const historyRef = useRef(null);
    const addRef = useRef(null);

    // Scroll handlers for the two sections
    const scrollToExerciseDetail = () => {
        if (exerciseDetailRef.current) {
            exerciseDetailRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const scrollToHistory = () => {
        if (historyRef.current) {
            historyRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const scrollToAdd = () => {
        if (addRef.current) {
            addRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="container-fluid">
            <div className="sticky-buttons">
                <Button theme="info" onClick={scrollToExerciseDetail}>
                    Xem chi tiết bài tập
                </Button>
                <Button theme="info" onClick={scrollToHistory}>
                    Xem Lịch sử tập của bạn
                </Button>
                <Button theme="success" onClick={scrollToAdd}>
                    Thêm tư liệu buổi tập
                </Button>
            </div>
            {isLoading || isError ? (
                <h3 className="card-title">Mời chọn bài tập và bác sĩ</h3>
            ) : (
                <>
                    <div id="practice-tab-content" className="tab-content">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div
                                        className="card-header"
                                        ref={exerciseDetailRef}
                                    >
                                        <h4>
                                            <i className="fas fa-dumbbell text-primary" />{' '}
                                            {patientExerciseItem &&
                                                patientExerciseItem.data
                                                ? patientExerciseItem.data
                                                    .exercise.name
                                                : ''}
                                        </h4>
                                    </div>
                                    <div
                                        className="card-body"
                                        id="exercise-details"
                                    >
                                        {!isMobile ? (
                                            // <div className="clearfix">
                                            //     {videoLink && (
                                            //         <div
                                            //             ref={videoRef}
                                            //             style={{
                                            //                 float: 'right',
                                            //                 width: '45%',
                                            //                 margin: '0 0 1rem 1rem'
                                            //             }}
                                            //         >
                                            //             <ReactPlayer
                                            //                 url={videoLink}
                                            //                 width="100%"
                                            //                 height="auto"
                                            //                 controls
                                            //                 playing={false}
                                            //                 muted
                                            //                 loop
                                            //             />
                                            //         </div>
                                            //     )}

                                            //     <h4>
                                            //         <i className="fas fa-dumbbell text-primary" />{' '}
                                            //         {exerciseItem?.data?.name}
                                            //     </h4>
                                            //     <div className="html-dangerouslySetInner" ref={descRef}>
                                            //         <span
                                            //             dangerouslySetInnerHTML={{
                                            //                 __html:
                                            //                     exerciseItem
                                            //                         ?.data
                                            //                         ?.description ||
                                            //                     ''
                                            //             }}
                                            //         />
                                            //     </div>
                                            //     <p>
                                            //         <i className="fas fa-user-md text-info" />{' '}
                                            //         Được điều trị bởi:{' '}
                                            //         {
                                            //             accountDoctorItem?.data
                                            //                 ?.pseudonym
                                            //         }{' '}
                                            //         {
                                            //             accountDoctorItem?.data
                                            //                 ?.fullName
                                            //         }
                                            //     </p>
                                            //     <p>
                                            //         <i className="fas fa-redo text-warning" />{' '}
                                            //         Số lần tập:{' '}
                                            //         {
                                            //             exerciseItem?.data
                                            //                 ?.practiceCountMinimum
                                            //         }{' '}
                                            //         –{' '}
                                            //         {
                                            //             exerciseItem?.data
                                            //                 ?.practiceCountMaximum
                                            //         }
                                            //     </p>
                                            // </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    {videoLink && (
                                                        <div
                                                            ref={videoRef}
                                                            className="float-md-end w-100 w-md-50 ms-md-3 mb-3"
                                                            style={{
                                                                maxWidth: '45%'
                                                            }}
                                                        >
                                                            <ReactPlayer
                                                                url={videoLink}
                                                                width="100%"
                                                                height="auto"
                                                                // onReady={
                                                                //     doMeasure
                                                                // }
                                                                controls
                                                                muted
                                                                loop
                                                                playing
                                                                playsinline
                                                            />
                                                        </div>
                                                    )}

                                                    {/* <h4>
                                                        <i className="fas fa-dumbbell text-primary" />{' '}
                                                        {
                                                            exerciseItem?.data
                                                                ?.name
                                                        }
                                                    </h4> */}

                                                    <div
                                                        ref={descRef}
                                                        className="html-dangerouslySetInner"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                patientExerciseItem
                                                                    ?.data
                                                                    ?.exercise
                                                                    ?.description ||
                                                                ''
                                                        }}
                                                    />

                                                    <p>
                                                        <i className="fas fa-user-md text-info" />{' '}
                                                        Được điều trị bởi:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.accountDoctor
                                                                ?.pseudonym
                                                        }{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.accountDoctor
                                                                ?.fullName
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lượng cần tập mỗi lần
                                                        (số vòng/kg):{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lần cần tập tập mỗi
                                                        séc:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số séc cần tập mỗi buổi:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Tổng lượng mỗi buổi:{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum}{' '}
                                                        –{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum}
                                                    </p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mobile-desc">
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    patientExerciseItem
                                                                        ?.data
                                                                        ?.exercise
                                                                        ?.description ||
                                                                    ''
                                                            }}
                                                        />
                                                    </div>
                                                    <p>
                                                        <i className="fas fa-user-md text-info" />{' '}
                                                        Được điều trị bởi:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.accountDoctor
                                                                ?.pseudonym
                                                        }{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.accountDoctor
                                                                ?.fullName
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lượng cần tập mỗi lần
                                                        (số vòng/kg):{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lần cần tập tập mỗi
                                                        séc:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số séc cần tập mỗi buổi:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Tổng lượng mỗi buổi:{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum}{' '}
                                                        –{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum}
                                                    </p>
                                                </div>
                                                <div className="col-md-6 align-self-start">
                                                    {videoLink ? (
                                                        <div className="player-wrapper">
                                                            <ReactPlayer
                                                                key={videoLink}
                                                                url={videoLink}
                                                                className="react-player"
                                                                width="100%"
                                                                height="100%"
                                                                controls
                                                                playing
                                                                muted
                                                                loop
                                                                playsinline
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="videoLink-placeholder bg-light d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: 200,
                                                                borderRadius: 5
                                                            }}
                                                        >
                                                            <p>
                                                                <i className="fas fa-videoLink fa-2x mb-2" />
                                                                <br />
                                                                'Xem videoLink
                                                                hướng dẫn ở đây'
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="status-display mt-4 pt-3 border-top">
                                            <h5>
                                                Trạng thái:{' '}
                                                <span className="status status-in-progress">
                                                    {objectPracticeStatus.find(
                                                        (x) =>
                                                            x.value ===
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.patientExerciseStatus
                                                    )?.label ??
                                                        objectPracticeStatus[0]
                                                            .label}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" ref={historyRef}>
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Lịch sử tập của bạn
                                        </h3>
                                    </div>

                                    <h5
                                        className="mb-3"
                                        style={{
                                            marginLeft: '20px',
                                            marginTop: '20px'
                                        }}
                                    >
                                        Các buổi tập của tôi
                                    </h5>

                                    {patientExerciseItem &&
                                        patientExerciseItem.data &&
                                        patientExerciseItem.data
                                            .patientExercisePractices &&
                                        patientExerciseItem.data
                                            .patientExercisePractices.length > 0 ? (
                                        patientExerciseItem.data.patientExercisePractices
                                            .sort(
                                                (a, b) =>
                                                    new Date(
                                                        a.createdDate
                                                    ).getTime() -
                                                    new Date(
                                                        b.createdDate
                                                    ).getTime()
                                            )
                                            .map((item, index) => {
                                                const isVisible =
                                                    visibleVideos[item.id];
                                                return (
                                                    <div
                                                        className="card-body"
                                                        style={{
                                                            paddingTop: '0px',
                                                            paddingBottom: '0px'
                                                        }}
                                                    >
                                                        <div id="practice-history">
                                                            <h5 className="mb-3">
                                                                <i className="fas fa-history" />{' '}
                                                                Buổi {index + 1}
                                                            </h5>
                                                            <div className="practice-record">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span className="date">
                                                                        <i className="far fa-calendar-alt" />{' '}
                                                                        {formatDateTimeMoment(
                                                                            item.createdDate
                                                                        )}
                                                                    </span>
                                                                    <div className="d-flex align-items-center">
                                                                        <span className="badge badge-success ml-2">
                                                                            <i className="fas fa-videoLink" />
                                                                            {item.videoLinks &&
                                                                                item
                                                                                    .videoLinks
                                                                                    .length >
                                                                                0
                                                                                ? 'Video đã upload'
                                                                                : 'Không có Video'}
                                                                        </span>

                                                                        {patientExerciseItem
                                                                            .data
                                                                            .patientExerciseStatus ==
                                                                            practiceStatus.InProgress ? (
                                                                            <span>
                                                                                <NavLink
                                                                                    to={{
                                                                                        // pathname:
                                                                                        //     location.pathname,
                                                                                        search: location.search // giữ lại mọi query string hiện tại
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        deleteAction(
                                                                                            item.id,
                                                                                            `Buổi ${index +
                                                                                            1
                                                                                            }`
                                                                                        )
                                                                                    }
                                                                                    // to
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Xóa"
                                                                                        className="nav-icon font-icon far fa-trash-alt"
                                                                                    />
                                                                                </NavLink>
                                                                            </span>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <p className="mt-2 mb-1">
                                                                    <i className="fas fa-dumbbell" />{' '}
                                                                    Số lượng tập
                                                                    (số
                                                                    vòng/kg):{' '}
                                                                    <strong>
                                                                        {
                                                                            item.quantityPratice
                                                                        }
                                                                    </strong>
                                                                </p>
                                                                <p className="mt-2 mb-1">
                                                                    <i className="fas fa-dumbbell" />{' '}
                                                                    Số lần tập:{' '}
                                                                    <strong>
                                                                        {
                                                                            item.timesPractice
                                                                        }
                                                                    </strong>
                                                                </p>
                                                                <p className="mt-2 mb-1">
                                                                    <i className="fas fa-dumbbell" />{' '}
                                                                    Số séc tập:{' '}
                                                                    <strong>
                                                                        {
                                                                            item.numOfSecPractice
                                                                        }
                                                                    </strong>
                                                                </p>
                                                                <Button
                                                                    theme="primary"
                                                                    onClick={() =>
                                                                        toggleVideo(
                                                                            item.id
                                                                        )
                                                                    }
                                                                >
                                                                    {isVisible
                                                                        ? 'Ẩn video'
                                                                        : 'Xem lại video'}
                                                                </Button>

                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'flex',
                                                                        flexWrap:
                                                                            'wrap',
                                                                        gap: '12px' // khoảng cách giữa các video
                                                                    }}
                                                                >
                                                                    {isVisible &&
                                                                        item
                                                                            .videoLinks
                                                                            .length >
                                                                        0 &&
                                                                        item.videoLinks.map(
                                                                            (
                                                                                video,
                                                                                videoIndex
                                                                            ) => (
                                                                                <div
                                                                                    key={
                                                                                        videoIndex
                                                                                    }
                                                                                    className="player-wrapper"
                                                                                    style={{
                                                                                        flex: '0 1 30%', // mỗi video chiếm tối đa 30% chiều ngang, có thể co lại
                                                                                        minWidth:
                                                                                            '200px' // đảm bảo video không quá nhỏ
                                                                                    }}
                                                                                >
                                                                                    {console.log(
                                                                                        'video',
                                                                                        BaseGatewayImage +
                                                                                        video
                                                                                    )}
                                                                                    <ReactPlayer
                                                                                        key={
                                                                                            video
                                                                                        }
                                                                                        url={
                                                                                            BaseGatewayImage +
                                                                                            video
                                                                                        }
                                                                                        className="react-player"
                                                                                        width="100%"
                                                                                        height="100%"
                                                                                        controls
                                                                                        playing
                                                                                        loop
                                                                                        muted
                                                                                        playsinline
                                                                                    />
                                                                                </div>
                                                                            )
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                    ) : (
                                        <div className="card-body">
                                            <div id="practice-history">
                                                <div className="alert alert-info">
                                                    <i className="fas fa-info-circle" />{' '}
                                                    Chưa có buổi tập nào. Mời
                                                    thêm buổi tập!
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {patientExerciseItem &&
                                        patientExerciseItem.data &&
                                        patientExerciseItem.data
                                            .patientExercisePractices &&
                                        patientExerciseItem.data
                                            .patientExercisePractices.length > 0 ? (
                                        <Form.Group as={Row} className="mb-3">
                                            <Col
                                                xs={{
                                                    span: 10,
                                                    offset: 1
                                                }}
                                                md={{
                                                    span: 10,
                                                    offset: 5
                                                }}
                                            >
                                                <ButtonGroup className="mb-2">
                                                    {patientExerciseItem.data
                                                        .patientExerciseStatus ==
                                                        practiceStatus.InProgress &&
                                                        timeCurentDay >=
                                                        moment(
                                                            patientExerciseItem
                                                                .data.fromDate
                                                        ) &&
                                                        timeCurentDay <=
                                                        moment(
                                                            patientExerciseItem
                                                                .data.toDate
                                                        ) ? (
                                                        <Button
                                                            style={{
                                                                marginLeft:
                                                                    'auto',
                                                                marginRight:
                                                                    'auto',
                                                                width: '20%',
                                                                marginBottom:
                                                                    '20px'
                                                            }}
                                                            onClick={() =>
                                                                handleUpdatePracticeStatus(
                                                                    practiceStatus.Pending,
                                                                    patientExerciseItem
                                                                        .data.id
                                                                )
                                                            }
                                                            className="btn btn-primary"
                                                            activeClassName="active" // adds .active when route matches
                                                        >
                                                            <i className="fas fa-check-circle" />{' '}
                                                            Bạn đã tập xong lần
                                                            này?
                                                        </Button>
                                                    ) : (
                                                        <></>
                                                    )}

                                                    {patientExerciseItem.data
                                                        .patientExerciseStatus ==
                                                        practiceStatus.Pending &&
                                                        timeCurentDay >=
                                                        moment(
                                                            patientExerciseItem
                                                                .data.fromDate
                                                        ) &&
                                                        timeCurentDay <=
                                                        moment(
                                                            patientExerciseItem
                                                                .data.toDate
                                                        ) ? (
                                                        <Button
                                                            style={{
                                                                marginLeft:
                                                                    'auto',
                                                                marginRight:
                                                                    'auto',
                                                                width: '20%',
                                                                marginBottom:
                                                                    '20px'
                                                            }}
                                                            onClick={() =>
                                                                handleUpdatePracticeStatus(
                                                                    practiceStatus.InProgress,
                                                                    patientExerciseItem
                                                                        .data.id
                                                                )
                                                            }
                                                            className="btn btn-danger"
                                                            activeClassName="active" // adds .active when route matches
                                                        >
                                                            {/* <i className="fas fa-uncheck-circle" />{' '} */}
                                                            Thu hồi
                                                        </Button>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </ButtonGroup>
                                            </Col>
                                        </Form.Group>
                                    ) : (
                                        <></>
                                    )}

                                    {(patientExerciseItem &&
                                        patientExerciseItem.data &&
                                        patientExerciseItem.data
                                            .patientExerciseStatus ==
                                        practiceStatus.Reviewed) ||
                                        patientExerciseItem.data
                                            .patientExerciseStatus ==
                                        practiceStatus.Rejected ? (
                                        <div className="row">
                                            <div className="col-md-6">
                                                {patientExerciseItem.data
                                                    .feedbackDoctor && (
                                                        <div
                                                            className="card card-info card-outline"
                                                            id="doctor-feedback-section"
                                                        // style={{display: 'none'}}
                                                        >
                                                            <div className="card-header">
                                                                <h3 className="card-title">
                                                                    Bác sĩ phản hồi
                                                                </h3>
                                                            </div>
                                                            <div
                                                                className="card-body"
                                                                id="doctor-feedback-container"
                                                            >
                                                                {
                                                                    patientExerciseItem
                                                                        .data
                                                                        .feedbackDoctor
                                                                }
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className="card card-success card-outline"
                                                    id="patient-response-section"
                                                // style={{display: 'none'}}
                                                >
                                                    <div className="card-header">
                                                        <h3 className="card-title">
                                                            Tôi phản hồi
                                                        </h3>
                                                    </div>
                                                    <div className="card-body">
                                                        <div id="patient-response-container">
                                                            {/* Will be populated by JavaScript */}
                                                        </div>
                                                        <div id="response-form-container">
                                                            <Formik
                                                                validationSchema={
                                                                    schemaPatientResponse
                                                                }
                                                                onSubmit={(
                                                                    values
                                                                ) =>
                                                                    handleUpdate(
                                                                        values,
                                                                        patientExerciseItem
                                                                            .data
                                                                            .id
                                                                    )
                                                                }
                                                                initialValues={{
                                                                    feedbackPatient:
                                                                        patientExerciseItem
                                                                            .data
                                                                            .feedbackPatient
                                                                            ? patientExerciseItem
                                                                                .data
                                                                                .feedbackPatient
                                                                            : ''
                                                                }}
                                                            >
                                                                {({
                                                                    handleSubmit,
                                                                    handleChange,
                                                                    values,
                                                                    errors,
                                                                    setFieldValue
                                                                }) => (
                                                                    <Form
                                                                        noValidate
                                                                        onSubmit={
                                                                            handleSubmit
                                                                        }
                                                                    >
                                                                        <Form.Group
                                                                            as={
                                                                                Row
                                                                            }
                                                                            className="mb-3"
                                                                        >
                                                                            <Form.Control
                                                                                placeholder="Bệnh nhân phản hồi"
                                                                                as="textarea"
                                                                                rows={
                                                                                    4
                                                                                }
                                                                                name="feedbackPatient"
                                                                                value={
                                                                                    values.feedbackPatient
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                            // disabled={
                                                                            //     item.feedbackPatient
                                                                            //         ? true
                                                                            //         : false
                                                                            // }
                                                                            // isInvalid={!!errors.practiceCountMinimum}
                                                                            />
                                                                            <div
                                                                                style={{
                                                                                    display:
                                                                                        'block',
                                                                                    color: '#dc3545'
                                                                                }}
                                                                                className="invalid-feedback"
                                                                            >
                                                                                {
                                                                                    errors.feedbackPatient
                                                                                }
                                                                            </div>
                                                                        </Form.Group>
                                                                        {!patientExerciseItem
                                                                            .data
                                                                            .feedbackPatient ? (
                                                                            <Form.Group
                                                                                as={
                                                                                    Row
                                                                                }
                                                                                className="mb-3"
                                                                            >
                                                                                <Col
                                                                                    md={{
                                                                                        span: 10,
                                                                                        offset: 2
                                                                                    }}
                                                                                >
                                                                                    <ButtonGroup className="mb-2">
                                                                                        <Button
                                                                                            type="submit"
                                                                                            theme="primary"
                                                                                        // disabled={
                                                                                        //     isLoading
                                                                                        // }
                                                                                        >
                                                                                            Phản
                                                                                            hồi
                                                                                        </Button>
                                                                                    </ButtonGroup>
                                                                                </Col>
                                                                            </Form.Group>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}
                                                                    </Form>
                                                                )}
                                                            </Formik>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                    {/* {item.patientExerciseStatus ==
                                                    practiceStatus.Reviewed ||
                                                item.patientExerciseStatus ==
                                                    practiceStatus.Rejected ? (
                                                    
                                                ) : (
                                                    <></>
                                                )} */}
                                </div>
                            </div>
                        </div>
                        {patientExerciseItem &&
                            patientExerciseItem.data &&
                            inforAccount.id &&
                            timeCurentDay >=
                            moment(patientExerciseItem.data.fromDate) &&
                            timeCurentDay <=
                            moment(patientExerciseItem.data.toDate) ? (
                            <div className="row" ref={addRef}>
                                <div className="col-md-12">
                                    <div className="card card-primary card-outline">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                Thêm tư liệu buổi tập
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            <Formik
                                                validationSchema={yup
                                                    .object()
                                                    .shape({
                                                        // example: require practiceCount to be ≥ minimum and ≤ maximum
                                                        quantityPratice: yup
                                                            .number()
                                                            .min(
                                                                patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .quantityMinimum
                                                                    : 0,
                                                                `Số lần tập mỗi buổi phải ≥ ${patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .quantityMinimum
                                                                    : 0
                                                                }`
                                                            )
                                                            .max(
                                                                patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .quantityMaximum
                                                                    : 0,
                                                                `Số lần tập mỗi buổi phải ≤ ${patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .quantityMaximum
                                                                    : 0
                                                                }`
                                                            )
                                                            .required(
                                                                'Trường dữ liệu không được để trống'
                                                            ),
                                                        timesPractice: yup
                                                            .number()
                                                            .min(
                                                                patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .timesMinimum
                                                                    : 0,
                                                                `Số lần tập mỗi buổi phải ≥ ${patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .timesMinimum
                                                                    : 0
                                                                }`
                                                            )
                                                            .max(
                                                                patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .timesMaximum
                                                                    : 0,
                                                                `Số lần tập mỗi buổi phải ≤ ${patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .timesMaximum
                                                                    : 0
                                                                }`
                                                            )
                                                            .required(
                                                                'Trường dữ liệu không được để trống'
                                                            ),
                                                        numOfSecPractice: yup
                                                            .number()
                                                            .min(
                                                                patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .numOfSecMinimum
                                                                    : 0,
                                                                `Số lần tập mỗi buổi phải ≥ ${patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .numOfSecMinimum
                                                                    : 0
                                                                }`
                                                            )
                                                            .max(
                                                                patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .numOfSecMaximum
                                                                    : 0,
                                                                `Số lần tập mỗi buổi phải ≤ ${patientExerciseItem &&
                                                                    patientExerciseItem.data
                                                                    ? patientExerciseItem
                                                                        .data
                                                                        .numOfSecMaximum
                                                                    : 0
                                                                }`
                                                            )
                                                            .required(
                                                                'Trường dữ liệu không được để trống'
                                                            ),
                                                        // videoLink: yup
                                                        //     .string()
                                                        //     .required(
                                                        //         'Trường dữ liệu không được để trống'
                                                        //     )
                                                        videoLinks: yup
                                                            .array()
                                                            .required(
                                                                'Bạn phải tải ít nhất 1 video'
                                                            )
                                                            .min(
                                                                1,
                                                                'Bạn phải tải ít nhất 1 video'
                                                            )
                                                            .test(
                                                                'videos-equals-sets',
                                                                'Số video tải lên phải bằng số séc tập',
                                                                function (
                                                                    videos
                                                                ) {
                                                                    const {
                                                                        numOfSecPractice
                                                                    } =
                                                                        this
                                                                            .parent;
                                                                    // nếu chưa nhập numOfSecPractice thì bỏ qua test (sẽ có required riêng)
                                                                    if (
                                                                        typeof numOfSecPractice !==
                                                                        'number'
                                                                    )
                                                                        return true;
                                                                    return (
                                                                        Array.isArray(
                                                                            videos
                                                                        ) &&
                                                                        videos.length ===
                                                                        numOfSecPractice
                                                                    );
                                                                }
                                                            )
                                                    })}
                                                onSubmit={async (
                                                    values,
                                                    { resetForm }
                                                ) => {
                                                    try {
                                                        await handleCreate(
                                                            values
                                                        );
                                                        resetForm(); // ← resets to initialValues
                                                    } catch (err) {
                                                        // handle error…
                                                    }
                                                }}
                                                initialValues={{
                                                    quantityPratice: 0,
                                                    timesPractice: 0,
                                                    numOfSecPractice: 0,
                                                    // videoLink: ''
                                                    videoLinks: []
                                                }}
                                            >
                                                {({
                                                    handleSubmit,
                                                    handleChange,
                                                    values,
                                                    errors,
                                                    setFieldValue,
                                                    setFieldTouched,
                                                    touched
                                                }) => (
                                                    <Form
                                                        noValidate
                                                        onSubmit={handleSubmit}
                                                    >
                                                        <Form.Group
                                                            as={Row}
                                                            className="mb-3"
                                                        >
                                                            <Form.Label className="col-sm-2 col-form-label">
                                                                Số lượng bạn tập
                                                                mỗi lần (số
                                                                vòng/kg)
                                                            </Form.Label>
                                                            <Col sm="10">
                                                                <Form.Control
                                                                    placeholder="Số lượng bạn tập mỗi lần (số vòng/kg)"
                                                                    type="number"
                                                                    name="quantityPratice"
                                                                    value={
                                                                        values.quantityPratice
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    isInvalid={
                                                                        !!errors.quantityPratice
                                                                    }
                                                                />
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'block',
                                                                        color: '#dc3545'
                                                                    }}
                                                                    className="invalid-feedback"
                                                                >
                                                                    {
                                                                        errors.quantityPratice
                                                                    }
                                                                </div>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Row}
                                                            className="mb-3"
                                                        >
                                                            <Form.Label className="col-sm-2 col-form-label">
                                                                Số lần bạn tập
                                                                mỗi séc
                                                            </Form.Label>
                                                            <Col sm="10">
                                                                <Form.Control
                                                                    placeholder="Số lần bạn tập mỗi séc"
                                                                    type="number"
                                                                    name="timesPractice"
                                                                    value={
                                                                        values.timesPractice
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    isInvalid={
                                                                        !!errors.timesPractice
                                                                    }
                                                                />
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'block',
                                                                        color: '#dc3545'
                                                                    }}
                                                                    className="invalid-feedback"
                                                                >
                                                                    {
                                                                        errors.timesPractice
                                                                    }
                                                                </div>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Row}
                                                            className="mb-3"
                                                        >
                                                            <Form.Label className="col-sm-2 col-form-label">
                                                                Số séc bạn tập
                                                                trong buổi
                                                            </Form.Label>
                                                            <Col sm="10">
                                                                <Form.Control
                                                                    placeholder="Số séc bạn tập trong buổi"
                                                                    type="number"
                                                                    name="numOfSecPractice"
                                                                    value={
                                                                        values.numOfSecPractice
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    isInvalid={
                                                                        !!errors.numOfSecPractice
                                                                    }
                                                                />
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'block',
                                                                        color: '#dc3545'
                                                                    }}
                                                                    className="invalid-feedback"
                                                                >
                                                                    {
                                                                        errors.numOfSecPractice
                                                                    }
                                                                </div>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Row}
                                                            className="mb-3"
                                                        >
                                                            <Form.Label className="col-sm-2 col-form-label">
                                                                Đường dẫn
                                                                videoLink
                                                            </Form.Label>
                                                            <Col sm="10">
                                                                {/* <VideoInput
                                                                isInvalid={
                                                                    !!errors.videoLink
                                                                }
                                                                errorsValue={
                                                                    errors.videoLink
                                                                }
                                                                value={
                                                                    values.videoLink
                                                                }
                                                                enableReinitialize={
                                                                    true
                                                                }
                                                                onChangeProp={(
                                                                    value
                                                                ) => {
                                                                    setFieldValue(
                                                                        'videoLink',
                                                                        value
                                                                    );
                                                                }}
                                                            /> */}
                                                                <MultiVideoInput
                                                                    isInvalid={
                                                                        !!errors.videoLinks
                                                                    }
                                                                    errorsValue={
                                                                        errors.videoLinks
                                                                    }
                                                                    value={
                                                                        values.videoLinks
                                                                    }
                                                                    enableReinitialize={
                                                                        true
                                                                    }
                                                                    onChangeProp={(
                                                                        value
                                                                    ) => {
                                                                        setFieldValue(
                                                                            'videoLinks',
                                                                            value
                                                                        );
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Row}
                                                            className="mb-3"
                                                        >
                                                            <Col
                                                                md={{
                                                                    span: 10,
                                                                    offset: 2
                                                                }}
                                                            >
                                                                <ButtonGroup className="mb-2">
                                                                    {timeCurentDay <=
                                                                        moment(
                                                                            patientExerciseItem
                                                                                .data.toDate
                                                                        ) && patientExerciseItem.data
                                                                            .patientExerciseStatus !==
                                                                        practiceStatus.Reviewed && patientExerciseItem.data
                                                                            .patientExerciseStatus !==
                                                                        practiceStatus.Rejected ?
                                                                        <Button
                                                                            type="submit"
                                                                            theme="primary"
                                                                        // disabled={
                                                                        //     isLoading
                                                                        // }
                                                                        >
                                                                            Thêm
                                                                        </Button> : <></>}
                                                                    &nbsp;&nbsp;&nbsp;
                                                                    <Button
                                                                        onClick={() =>
                                                                            history.goBack()
                                                                        }
                                                                        theme="secondary"
                                                                    >
                                                                        Hủy
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </Col>
                                                        </Form.Group>
                                                    </Form>
                                                )}
                                            </Formik>
                                            {/* <form id="add-practice-form">
                                            <div className="form-group">
                                                <label htmlFor="practice-count">
                                                    Số lần bạn tập trong buổi:
                                                </label>
                                                <input
                                                    type="number"
                                                    id="practice-count"
                                                    className="form-control"
                                                    min={1}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="practice-videoLink">
                                                    Upload videoLink (optional):
                                                </label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id="practice-videoLink"
                                                            accept="videoLink/*"
                                                        />
                                                        <label
                                                            className="custom-file-label"
                                                            htmlFor="practice-videoLink"
                                                        >
                                                            Choose file
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="practice-notes">
                                                    Notes (optional):
                                                </label>
                                                <textarea
                                                    id="practice-notes"
                                                    className="form-control"
                                                    rows={3}
                                                    defaultValue={''}
                                                />
                                            </div>
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                Add Practice Record
                                            </button>
                                        </form> */}
                                            <p
                                                id="practice-message"
                                                className="mt-3"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        handleAccept={() => acceptDelete()}
                        handleCancel={() => cancelDelete()}
                        content={confirmDelMessage}
                    />
                </>
            )}
        </div>
    );
};

export default PatientPractice;
